import { SharedConstants } from "../../../shared/constants/shared.constants";
export class ViewApplicationAddNoteConstants {
    static COMPONENT_NAME = "Notes";
    static SAVE_NOTE_TEXT = "Save note";
    static NOTE_FORM_CONTROL_NAME = "note";
    static LINK_NOTE_TO_STEP_FORM_CONTROL_NAME = "linkNoteToStep";
    static LINK_NOTE_TO_STEP_LABEL = "Link to current step";
    static VALIDATION_MESSAGE = {
        note: {
            required: `Note ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
        }
    };
}
